export default __webpack_public_path__ + "static/media/checkmark.dd9377d3.svg";